import type { License } from '@/modules/licenses/types.ts'
import { apiClient } from '@/utils/axios.ts'

async function getLicense(creatorId: number): Promise<License> {
  const res = await apiClient.get(`creators/${creatorId}/license`)

  return res.data
}

async function getLicenses(): Promise<License[]> {
  const res = await apiClient.get('licenses')

  return res.data
}

async function postLicense(creatorId: number, licenseId: number): Promise<any> {
  const res = await apiClient.post(`creators/${creatorId}/license`, {
    licenseId,
  })

  return res.data
}

export const licensesService = {
  getLicense,
  getLicenses,
  postLicense,
}
